import * as yup from 'yup'
import yupValidation from '../../lib/yupValidation'

const motoristaStepSchema = yup.object().shape({
  fotoLegivel: yup.string().required('Obrigatório'),
  cnhLegivel: yup.string().required('Obrigatório'),
  comprovanteEndereco: yup.string().nullable(),
  comprovanteValido: yup
    .string()
    .nullable()
    .when('comprovanteEndereco', {
      is: comprovanteEndereco => !!comprovanteEndereco,
      then: yup.string().required('Obrigatório')
    })
})

const veiculosStepSchema = yup.object().shape({
  veiculos: yup.array().of(
    yup.object().shape({
      crlvLegivel: yup.string().required('Obrigatório')
    })
  ),
  contatoMotorista: yup.boolean().required('Obrigatório'),
  contatoResponsavel: yup.boolean().required('Obrigatório'),
  contratoArrendamento: yup.string().nullable(),
  contratoValido: yup
    .string()
    .nullable()
    .when('contratoArrendamento', {
      is: contratoArrendamento => !!contratoArrendamento,
      then: yup.string().required()
    })
})

const mergedSchema = yup.object().shape({
  veiculos: yup.array().of(
    yup.object().shape({
      crlvLegivel: yup.boolean().required('Obrigatório')
    })
  ),
  contatoResponsavel: yup.boolean().required('Obrigatório'),
  contatoMotorista: yup.boolean().required('Obrigatório'),
  contratoArrendamento: yup.string().nullable(),
  contratoValido: yup
    .boolean()
    .nullable()
    .when('contratoArrendamento', {
      is: contratoArrendamento => !!contratoArrendamento,
      then: yup.boolean().required()
    }),
  motorista: yup.object().shape({
    fotoLegivel: yup.boolean().required('Obrigatório'),
    cnhLegivel: yup.boolean().required('Obrigatório'),
    comprovanteEndereco: yup.string().nullable(),
    comprovanteValido: yup
      .boolean()
      .nullable()
      .when('comprovanteEndereco', {
        is: comprovanteEndereco => !!comprovanteEndereco,
        then: yup.boolean().required('Obrigatório')
      })
  })
})

export const changeStepValidate = async (values, currentStep) => {
  switch (currentStep) {
    case 2: {
      const errors = await yupValidation(motoristaStepSchema)(values.motorista)
      return errors
    }

    case 3: {
      const errors = await yupValidation(veiculosStepSchema)(values)
      return errors
    }

    default:
      return {}
  }
}

export const validateAllRadios = async values => {
  const errors = await yupValidation(mergedSchema)(values)
  return errors
}

export default changeStepValidate
